import { LocationModel, LocationPayload } from '../../../../types/Location';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareUpdateLocation = ({
    locationElement,
    payload,
}: {
    locationElement: LocationModel;
    payload: LocationPayload;
}) =>
    locationElement.prepareUpdate((location) => {
        location.placeId = payload.placeId;
        location.name = payload.name;
        location.lat = `${payload.lat}`;
        location.lng = `${payload.lng}`;
        location.url = payload.url;
        location.utcOffset = payload.utcOffset;
        location.userId = locationElement.userId;
        location.organisationId = locationElement.organisationId;
    });

export const logUpdateLocationAction = ({
    location,
    logDBAction,
    tableName,
}: {
    location: LocationModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Update location',
        modelName: tableName,
        payload: location,
    });
};
